import React from "react";
import { connect } from "react-redux";

import { nombreProductoGM, getNumPoliza } from "../common/logica";
import { getFechasVigencia } from "./logicaFechas";

const mapState = (state) => {
	return {
		"polizasCargadas": state.polizas.polizasCargadas
	};
};

class ListPoliza extends React.Component {
	render() {
		let item = this.props.item, i = this.props.i;
		let estatus = "...";
		let fechas = getFechasVigencia(item);

		if (this.props.polizasCargadas) {
			if (item.generales.estatus != "") {
				estatus = "Sí";
			} else {
				estatus = "No";
			}
		}

		return <li className="row" key={i} onClick={this.props.setDetalle.bind(this, [item, item.generales.cveRamo])}>
			<div className="hide-mobile">
				<div className="col-xs-6 col-sm-3" >
					<h6>{ getNumPoliza(item) }</h6>
				</div>
				{ item.generales.cveRamo == "A" &&
					<div className="col-xs-6 col-sm-3">
						<h6 >{item.vehiculo.descripcion} {item.vehiculo.modelo}</h6>
						<h6 style={{"fontWeight":"normal"}}>Placas: {item.vehiculo.placas}</h6>
					</div>
				}
				{ item.generales.cveRamo == "G" &&
					<div className="col-xs-6 col-sm-3">
						<h6>{ nombreProductoGM(item) }</h6>
					</div>
				}
				{ item.generales.cveRamo == "V" &&
					<div className="col-xs-6 col-sm-3">
						<h6>{ item.generales.productoComercial }</h6>
					</div>
				}
				{ item.generales.cveRamo == "D" &&
					<div className="col-xs-6 col-sm-3">
						<h6>{ item.generales.productoComercial }</h6>
					</div>
				}
				<div className="col-xs-6 col-sm-3" >
					{ !(item.generales.cveProdComercial == "00012" && item.generales.cveProdTecnico == "A2400FLOT") && // AUTO MAS
						!(item.generales.cveProdComercial == "00002" && item.generales.cveProdTecnico == "V1011PFLVM") && // VIDA MAS
						!(item.generales.cveProdComercial == "00003" && item.generales.cveProdTecnico == "V1011PFLVM") && // VIDA MAS INCREMENTO
						<h6 className="center-text" onClick={this.pendiente} >{ estatus }</h6>
					}
					{ ( (item.generales.cveProdComercial == "00012" && item.generales.cveProdTecnico == "A2400FLOT") || // AUTO MAS
						(item.generales.cveProdComercial == "00002" && item.generales.cveProdTecnico == "V1011PFLVM") || // VIDA MAS
						(item.generales.cveProdComercial == "00003" && item.generales.cveProdTecnico == "V1011PFLVM") ) && // VIDA MAS INCREMENTO
						<h6 className="center-text" >N/A</h6>
					}
				</div>
				<div className="col-xs-6 col-sm-3" >
					<div className="vigencia" style={{"marginTop": 10}}>
						<p><span className="blue-circle"></span>Desde el { fechas.inicioLargo }</p>
						<p><span className="orange-point"></span>Hasta el { fechas.finLargo }</p>
					</div>
				</div>
			</div>
			<div className="show-mobile lista-polizas">
				<div className="row">
					{ item.generales.cveRamo == "A" &&
						<div className="col-xs-8 col-sm-6">
							<h6 className="crop-text">{item.vehiculo.descripcion}</h6>
						</div>
					}
					{ item.generales.cveRamo == "G" &&
						<div className="col-xs-8 col-sm-6">
							<h6 className="crop-text">{ item.generales.productoComercial } </h6>
						</div>
					}
					{ item.generales.cveRamo == "V" &&
						<div className="col-xs-8 col-sm-6">
							<h6 className="crop-text">{ item.generales.productoComercial }</h6>
						</div>
					}
					{ item.generales.cveRamo == "D" &&
						<div className="col-xs-8 col-sm-6">
							<h6 className="crop-text">{ item.generales.productoComercial }</h6>
						</div>
					}   

					{ item.generales.cveRamo == "A" &&
						<div className="col-xs-4 col-sm-6">
							<h6 className="center-text">Pendiente de pago</h6>
						</div>
					}
					{ item.generales.cveRamo != "A" &&
						<div className="col-xs-4 col-sm-6">
							<h6 className="center-text">Pendiente de pago</h6>
						</div>
					}
				</div>
				<div className="row">
					<div className="col-xs-8 col-sm-6">
						<h6><img src={require("../img/icon_poliza.png")} alt=""/><b>No. Póliza: { getNumPoliza(item) }</b></h6>
					</div>
					<div className="col-xs-4 col-sm-6">
						{ !(item.generales.cveProdComercial == "00012" && item.generales.cveProdTecnico == "A2400FLOT") && // AUTO MAS
							!(item.generales.cveProdComercial == "00002" && item.generales.cveProdTecnico == "V1011PFLVM") && // VIDA MAS
							!(item.generales.cveProdComercial == "00003" && item.generales.cveProdTecnico == "V1011PFLVM") && // VIDA MAS INCREMENTO
							<h6 className="status-poliza">{ estatus }</h6>
						}
						{ ( (item.generales.cveProdComercial == "00012" && item.generales.cveProdTecnico == "A2400FLOT") || // AUTO MAS
							(item.generales.cveProdComercial == "00002" && item.generales.cveProdTecnico == "V1011PFLVM") || // VIDA MAS
							(item.generales.cveProdComercial == "00003" && item.generales.cveProdTecnico == "V1011PFLVM") ) && // VIDA MAS INCREMENTO
							<h6 className="status-poliza">N/A</h6>
						}
					</div>
				</div>
			</div>
		</li>;
	}
}

export default connect(mapState)(ListPoliza);


// WEBPACK FOOTER //
// ./src/home/listPoliza.cmpt.js